import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import colors from "../../../config/colors";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtCrewAppSection({}) {
  const isMobile = useMobile();
  const renderRow = (icon, text, containerStyle) => {
    return (
      <View
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: "white",
            padding: 18,
            borderRadius: 10,
          },
          containerStyle,
        ]}
      >
        <View
          style={{
            backgroundColor: "#dfdfdf",
            borderRadius: 20,
            padding: 8,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <NtMaterialIcon name={icon} color={colors.almostBlack} />
        </View>

        <NtText
          style={{
            marginLeft: 6,
            fontSize: 12,
            fontWeight: "500",
            color: colors.almostBlack,
          }}
        >
          {text}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/8a975b95cae7f297167be8c155b4a5d1919c8e00.jpg")}
    >
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
        }}
      >
        {/* left side */}
        <View
          style={{ flex: isMobile ? 1 : 2, paddingLeft: 15, paddingRight: 15 }}
        >
          <NtSectionTitle style={{ textAlign: "left", fontSize: 28 }}>
            CREW APP
          </NtSectionTitle>
          <NtSectionDescription>
            It Allows the Crew to Stay Connected While Living and Working on the
            Cruise Ship
          </NtSectionDescription>
          <View
            style={{
              marginTop: 30,
            }}
          >
            {renderRow("rocket-launch", "Boost Job Performance", {
              flex: 1,
            })}
            {renderRow("hand-heart", "Improve Crew Welfare", {
              flex: 1,
              marginTop: 10,
            })}
            {renderRow("account-circle", "Engance Guest Relations", {
              flex: 1,
              marginTop: 10,
            })}
          </View>
        </View>

        {/* right side */}
        {!isMobile && (
          <View style={{ flex: 1, alignItems: "center" }}>
            <Image
              style={[
                {
                  width: 150,
                  height: 300,
                  resizeMode: "contain",
                },
              ]}
              source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
            />
          </View>
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    height: 650,
  },
});

export default NtCrewAppSection;
